import { createAction } from '@reduxjs/toolkit';

import type { BrandKit, BrandKitColor, ImageAssetModel } from 'js/src/client';
import type { BrandKitFontId } from 'js/src/data/brand-kits/brand-kits-types';
import { BRAND_KIT_EDITOR_ACTIONS } from 'js/src/data/brand-kits-editor/brand-kits-editor-types';

export const setSelectedBrandKit = createAction<{
    brandKit: BrandKit;
}>(BRAND_KIT_EDITOR_ACTIONS.SET_SELECTED_BRAND_KIT);

export const resetSelectedBrandKit = createAction(
    BRAND_KIT_EDITOR_ACTIONS.RESET_SELECTED_BRAND_KIT,
);

export const setSelectedBrandKitName = createAction<{
    name: string;
}>(BRAND_KIT_EDITOR_ACTIONS.SET_BRAND_KIT_EDITOR_NAME);

export const setSelectedBrandKitColor = createAction<{
    color: BrandKitColor;
    index: number;
}>(BRAND_KIT_EDITOR_ACTIONS.SET_BRAND_KIT_EDITOR_COLOR);

export const deleteSelectedBrandKitColor = createAction<{
    index: number;
}>(BRAND_KIT_EDITOR_ACTIONS.DELETE_BRAND_KIT_EDITOR_COLOR);

export const addSelectedBrandKitColor = createAction<{
    color: BrandKitColor;
}>(BRAND_KIT_EDITOR_ACTIONS.ADD_BRAND_KIT_EDITOR_COLOR);

export const setSelectedBrandKitFont = createAction<{
    font: BrandKitFontId;
    index: number;
}>(BRAND_KIT_EDITOR_ACTIONS.SET_BRAND_KIT_EDITOR_FONT);

export const addSelectedBrandKitFont = createAction(
    BRAND_KIT_EDITOR_ACTIONS.ADD_BRAND_KIT_EDITOR_FONT,
);

export const deleteSelectedBrandKitFont = createAction<{
    index: number;
}>(BRAND_KIT_EDITOR_ACTIONS.DELETE_BRAND_KIT_EDITOR_FONT);

export const setSelectedBrandKitWatermark = createAction<{
    watermark: ImageAssetModel;
    index: number;
}>(BRAND_KIT_EDITOR_ACTIONS.SET_BRAND_KIT_EDITOR_WATERMARK);

export const addSelectedBrandKitWatermark = createAction(
    BRAND_KIT_EDITOR_ACTIONS.ADD_BRAND_KIT_EDITOR_WATERMARK,
);

export const deleteSelectedBrandKitWatermark = createAction<{
    index: number;
}>(BRAND_KIT_EDITOR_ACTIONS.DELETE_BRAND_KIT_EDITOR_WATERMARK);
